import { useDonateToGitcoin } from "../../DonateToGitcoinContext";
import { useState, useEffect } from "react";
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
function formatAmount(num) {
  return (Math.floor(num * 100) / 100).toFixed(2);
}
export function DonationInput(_ref) {
  let {
    totalAmount
  } = _ref;
  const {
    amount,
    setAmount,
    selectedTokenBalance,
    isEnabled
  } = useDonateToGitcoin();
  const [selectedPercentage, setSelectedPercentage] = useState(0);
  const percentages = [10, 15, 20];
  useEffect(() => {
    if (isEnabled) {
      const calculatedAmount = Number(totalAmount) * (10 / 100);
      setAmount(formatAmount(calculatedAmount));
      setSelectedPercentage(10);
    } else {
      setAmount("0.00");
    }
  }, [isEnabled, totalAmount, setAmount]);
  const handlePercentageClick = percentage => {
    const calculatedAmount = Number(totalAmount) * (percentage / 100);
    setAmount(formatAmount(calculatedAmount));
    setSelectedPercentage(percentage);
  };
  const handleChange = e => {
    const value = e.target.value;
    if (value === "" || /^\d*\.?\d*$/.test(value)) {
      setAmount(value);
      // Check if the new amount matches any percentage
      const newPercentage = percentages.find(p => formatAmount(Number(totalAmount) * (p / 100)) === value);
      setSelectedPercentage(newPercentage || 0);
    }
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "flex gap-2 items-center",
    children: [percentages.map(percentage => /*#__PURE__*/_jsxs("button", {
      onClick: () => handlePercentageClick(percentage),
      className: `
            flex justify-content-center items-center
            w-[68px] h-[32px]
            px-4 py-2
            rounded-[8px]
            border border-solid
            shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)]
            font-inter text-[12px] font-medium text-black
            ${selectedPercentage === percentage ? "border-[#7D67EB]" : "border-[#D7D7D7]"}
            bg-white
          `,
      children: ["+", percentage, "%"]
    }, percentage)), /*#__PURE__*/_jsxs("div", {
      className: "relative flex-[3]",
      children: [/*#__PURE__*/_jsx("div", {
        className: "absolute left-3 top-[10px] text-[14px] font-medium font-inter text-black",
        children: "$"
      }), /*#__PURE__*/_jsx("input", {
        type: "text",
        className: `
            w-full rounded-[6px] 
            border ${selectedPercentage === 0 ? "border-[#7D67EB]" : "border-[#D7D7D7]"}
            p-[7.5px] pr-3 pl-6
            text-[12px] font-medium font-inter text-black
            text-right
          `,
        value: amount,
        onChange: handleChange,
        placeholder: "Enter amount",
        max: selectedTokenBalance
      })]
    })]
  });
}